import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDropdownCommunityComponent } from './user-dropdown-community/user-dropdown-community.component';
import { MenuModule } from 'primeng/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
@NgModule({
  declarations: [UserDropdownCommunityComponent],
  exports: [UserDropdownCommunityComponent],
  imports: [CommonModule, MenuModule, FontAwesomeModule, SharedUtilsImageModule]
})
export class AuthenticationUserDropdownCommunityModule {}
